(function () {
    'use strict';

    angular
        .module('skillsApp')
        .value('cgBusyDefaults', {
            message: '',
            delay: 500,
            minDuration: 700,
            templateUrl: '/app/services/cgBusy/cgbusy.tpl.html'
        });
})();
